/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PostOpRecovery from './post-op-recovery';
import PostOpRecoveryDetail from './post-op-recovery-detail';
import PostOpRecoveryUpdate from './post-op-recovery-update';
import PostOpRecoveryDeleteDialog from './post-op-recovery-delete-dialog';

const PostOpRecoveryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PostOpRecovery />} />
    <Route path="new" element={<PostOpRecoveryUpdate />} />
    <Route path=":id">
      <Route index element={<PostOpRecoveryDetail />} />
      <Route path="edit" element={<PostOpRecoveryUpdate />} />
      <Route path="delete" element={<PostOpRecoveryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PostOpRecoveryRoutes;
